import type { SVGProps } from "react";
import * as React from "react";

const SvgBellOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#bell-off_svg__a)">
      <path
        fill="currentColor"
        d="M14.595 21.502a1 1 0 0 0-1.73-1.004zm-3.46-1.004a1 1 0 0 0-1.73 1.004zm6.53-7.235a1 1 0 0 0 1.93-.527zM18 8l1 .016v-.015zM7.216 6.555a1 1 0 0 0-1.912-.59zM6 8h1v-.002zm-3 9-.555-.832A1 1 0 0 0 3 18zm14 1a1 1 0 1 0 0-2zM8.115 2.168a1 1 0 1 0 1.11 1.664zM1.707.293A1 1 0 0 0 .293 1.707zm20.586 23.414a1 1 0 0 0 1.414-1.414zm-9.428-3.209a1 1 0 0 1-.366.365l.998 1.733a3 3 0 0 0 1.098-1.094zm-.366.365a1 1 0 0 1-.499.134v2a3 3 0 0 0 1.497-.4zm-.499.134a1 1 0 0 1-.5-.134l-.997 1.733a3 3 0 0 0 1.497.4zm-.5-.134a1 1 0 0 1-.365-.365l-1.73 1.004a3 3 0 0 0 1.098 1.094zm8.095-8.126A16.9 16.9 0 0 1 19 8.015l-2-.032a18.9 18.9 0 0 0 .665 5.28zM5.305 5.964A6.9 6.9 0 0 0 5 8.002l2-.004a4.9 4.9 0 0 1 .216-1.443zM5 8c0 3.353-.717 5.435-1.378 6.646a6 6 0 0 1-.88 1.244 3 3 0 0 1-.305.284q-.006.004-.004.003l.004-.003.004-.003.002-.001.001-.001s.001-.001.556.831.555.832.556.831h.001l.004-.003.006-.005.064-.045q.055-.04.138-.11c.11-.092.257-.224.426-.402a8 8 0 0 0 1.183-1.662C6.218 14.065 7 11.647 7 8zM3 18h14v-2H3zm16-9.999a7 7 0 0 0-.991-3.6l-1.717 1.025A5 5 0 0 1 17 8zm-.991-3.6a7 7 0 0 0-2.703-2.58l-.944 1.763a5 5 0 0 1 1.93 1.842zm-2.703-2.58A7 7 0 0 0 11.664 1l.096 1.998a5 5 0 0 1 2.603.587zM11.664 1a7 7 0 0 0-3.548 1.17l1.11 1.663a5 5 0 0 1 2.534-.835zm-11.37.708 22 22 1.414-1.414-22-22z"
      />
    </g>
    <defs>
      <clipPath id="bell-off_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBellOff;
